import React, { FunctionComponent } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { Icon } from '../../../components';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  onPress: () => void;
}

export const BackButton: FunctionComponent<IProps> = ({ onPress }) => {

  return (
    <TouchableOpacity onPress={onPress} style={styles.container}>
      <Icon name='ios-arrow-back' size={defaultScale(30)} color={Theme.GREY_MEDIUM}/>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingLeft: defaultScale(10),
    width: defaultScale(50),
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    zIndex: 1,
  },
});
